import { Slider, SliderController } from '../../components/Slider';
import { Slide } from '../../components/Slide';
import { Modal } from '../../components/Modal';
import { ModalOverlay } from '../../components/ModalOverlay';
import 'keen-slider/keen-slider.min.css';
import { SliderControlButton } from '../../components/SliderControlButton';
import Lockup from './assets/onboarding-lockup.svg';
import OnboardingBg from '../splash/assets/bloomscapes-bg.webp';
import ImageTargetIcon from './assets/image-target-icon.svg';
import EJLogo from '../../assets/ej-logo.svg';
import LebookLogo from '../../assets/lebook-logo.webp';
import MandalaLogo from '../../assets/mandala-logo.webp';
import ARIcon from './assets/ar-icon.webp';
import PlayHeader from './assets/play-header.svg';
import ScanHeader from './assets/scan-header.svg';
import { ExperienceType } from '../../atoms';

type OnboardingModalsProps = {
    mode: ExperienceType;
    onClose: () => void;
};

export const OnboardingModals = ({ mode, onClose }: OnboardingModalsProps) => {
    const sliderController: SliderController = {
        post: () => {},
    };
    return (
        <ModalOverlay>
            <Modal
                maxWidth="max-w-[390px]"
                maxHeight="max-h-[540px]"
                className=" bg-cover text-white centered w-[92%] rounded-none"
            >
                <Slider controller={sliderController}>
                    <Slide className="relative flex flex-col h-full justify-between bg-[#BD728C] bg-cover bg-center" style={{ backgroundImage: `url(${OnboardingBg})` }}>
                        {/* Dark overlay */}
                        <div className="absolute inset-0 bg-black/20 pointer-events-none" />
                        <div className="flex items-center justify-start gap-4 relative z-10">
                            <img
                                className="h-[34px]"
                                src={EJLogo}
                                alt="EyeJack Logo"
                            />
                            <img
                                className="h-[34px]"
                                src={MandalaLogo}
                                alt="Mandala Logo"
                            />
                            <img
                                className="h-[17px]"
                                src={LebookLogo}
                                alt="Lebook Logo"
                            />
                        </div>
                        <div className="flex flex-col flex-grow h-full items-center justify-center relative z-10">
                            <img src={Lockup} className="w-full" />
                        </div>
                        <SliderControlButton
                            sliderController={sliderController}
                            message="next"
                            text="NEXT"
                            className="relative z-10"
                        />
                    </Slide>
                    <Slide className="flex flex-col h-full justify-between bg-[#BD728C]">
                        <div className="flex flex-col flex-grow h-full justify-start gap-[30px]">
                            {mode === ExperienceType.IMAGES && (
                                <>
                                    <img
                                        src={ImageTargetIcon}
                                        className="max-w-[184px] w-full self-start"
                                    />
                                    <img
                                        src={ScanHeader}
                                        className="w-[76%] self-start"
                                    />
                                    <p className="text-lg font-mark-pro-xtralite leading-[110%]">
                                        To unlock the immersive musical and
                                        visual adventure behind each artwork,
                                        point your camera at any of the
                                        captivating pieces nearby and watch them
                                        come to life with augmented reality.
                                    </p>
                                </>
                            )}
                            {mode === ExperienceType.MODEL && (
                                <>
                                    <img
                                        src={ARIcon}
                                        className="max-w-[240px] w-full self-start"
                                    />
                                    <img
                                        src={PlayHeader}
                                        className="w-[76%] self-start"
                                    />
                                    <p className="text-lg font-mark-pro-xtralite leading-[125%]">
                                    You are about to view an augmented reality sculpture. Please follow the next step to position the experience.
                                    </p>
                                </>
                            )}
                        </div>
                        <SliderControlButton
                            sliderController={sliderController}
                            message="undefined"
                            text="BEGIN"
                            onClick={onClose}
                        />
                    </Slide>
                </Slider>
            </Modal>
        </ModalOverlay>
    );
};
